// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3y7Tx","left":"styles_left__1K8lZ"};